module.exports = __webpack_public_path__ + "static/key-basingstoke-973e7ca313284e77ea818e0cfa0721df.webp";